import { render, staticRenderFns } from "./MedicalCompletedApplications.vue?vue&type=template&id=1520f67e"
import script from "./MedicalCompletedApplications.vue?vue&type=script&lang=js"
export * from "./MedicalCompletedApplications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports